// extracted by mini-css-extract-plugin
export var content = "TalkMessageListView-module--content--48e6a";
export var form = "TalkMessageListView-module--form--7045d";
export var layout = "TalkMessageListView-module--layout--7973a";